// extracted by mini-css-extract-plugin
export default {"swatches":"uP4cg8hE9t","swatch":"U02OxqOxfN","input":"BMIFWaWP1z"};